import React, { useEffect, useState } from 'react'
import Node from './Node'
import {dijkstrasAlgo, getNodesInShortestPathOrder} from '../Algorithm/DijkstrasAlgo'

import './Main.css'

function Dijkstra() {
    const [currentState, setCurrentState] = useState({grid: [], mouseIsPressed: false});

    const START_NODE_ROW = 10;
    const START_NODE_COL = 15;
    const FINISH_NODE_ROW = 10;
    const FINISH_NODE_COL = 35;

    

    useEffect(() => {
        const getInitialGrid = () => {
            const grid = [];
            for (let row = 0; row < 20; row++) {
                const currentRow = [];
                for (let column = 0; column < 50; column++) {
                    currentRow.push(createNode(column, row));
                }
                grid.push(currentRow);
            }
            return grid;
        }
        const grid = getInitialGrid();
        setCurrentState({grid});
    }, []);

    

    const createNode = (column, row) => {
        return {
            column,
            row,
            isStart: row === START_NODE_ROW && column === START_NODE_COL,
            isFinish: row === FINISH_NODE_ROW && column === FINISH_NODE_COL,
            distance: Infinity,
            isVisited: false,
            isWall: false,
            previousNode: null,
        }
    }

    const handleMouseDown = (row, column) => {
        const newGrid = getNewGridWithWallToggled(currentState.grid, row, column);
        setCurrentState({grid: newGrid, mouseIsPressed: true});
    }

    const handleMouseEnter = (row, column) => {
        if (!currentState.mouseIsPressed) return;
        const newGrid = getNewGridWithWallToggled(currentState.grid, row, column);
        setCurrentState({grid: newGrid});
    }

    const handleMouseUp = () => {
        const newGrid = currentState.grid;
        setCurrentState({grid: newGrid, mouseIsPressed: false})
    }

    const getNewGridWithWallToggled = (grid, row, column) => {
        const newGrid = grid.slice();
        const node = newGrid[row][column];
        const newNode = {
            ...node,
            isWall: !node.isWall,
        };
        newGrid[row][column] = newNode;
        return newGrid;
    };

    const animateShortestPath = (nodesInShortestPathOrder) => {
        for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
            setTimeout(() => {
                const node = nodesInShortestPathOrder[i];
                document.getElementById(`node-${node.row}-${node.column}`).className = 'node node-shortest-path';
            }, 50 * i)
        }
    }

    const animatedDijkstra = (visitedNodesInOrder, nodesInShortestPathOrder) => {
        for (let i = 0; i <= visitedNodesInOrder.length; i++) {
            if (i === visitedNodesInOrder.length) {
                setTimeout(() => {
                    animateShortestPath(nodesInShortestPathOrder);
                }, 20 * i);
                return;
            }
            setTimeout(() => {
                const node = visitedNodesInOrder[i];
                document.getElementById(`node-${node.row}-${node.column}`).className = 'node node-visited';
            }, 20 * i);
        
        }
    }

    const visualizeDijkstra = () => {
        const {grid} = currentState;
        const startNode = grid[START_NODE_ROW][START_NODE_COL];
        const finishNode = grid[FINISH_NODE_ROW][FINISH_NODE_COL];
        const visitedNodesInOrder = dijkstrasAlgo(grid, startNode, finishNode);
        const nodesInShortestPathOrder = getNodesInShortestPathOrder(finishNode);
        animatedDijkstra(visitedNodesInOrder, nodesInShortestPathOrder);
    }

    
    const {grid, mouseIsPressed} = currentState;

    return (
        <div className='main'>
            <h1>This tool will help viewers visualize the Dijkstra Algorithm</h1>
            <h4>What is Dijkstra's Algorithm?</h4>
            <p>
                Dijkstra's algorithm, also known as the shortest path algorithm, was created 
                by Dr. Edsger W. Dijkstra. He made the algorithm in 1956 while having coffee 
                with his fiancé in Amsterdam. He also claimed that the algorithm took him 
                twenty minutes to develop.
            </p>
            <p>
                The primary purpose of this algorithm is to find the shortest path between two 
                nodes in a graph. A graph is a collection of nodes that may be directly or indirectly 
                referenced together. Some typical data structures are specialized types of graphs. 
                For example, linked lists and binary trees are just graphs that follow a specific 
                format.
            </p>
            <h4>How it Works:</h4>
            <ol>
                <li>Declare the starting node (green square) and an end node (red square).</li>
                <li>Create a structure to keep track of the distance between the source node and adjacent nodes.</li>
                <li>Set start node distance to zero, all other nodes to infinity.</li>
                <li>Grab the nodes closest to the source node, mark as visited.</li>
                <li>Continue until the closest node equals the finish node.</li>
                <li>Reverse the path from the finish node back to the source node.</li>
            </ol>
            <h4>Instructions:</h4>
            <ol>
                <li>Click on the grid squares to create barriers.</li>
                <li>Click "Run Dijkstra Algo" Button.</li>
            </ol>
            <button onClick={() => {
                visualizeDijkstra()
            }}>
                Run Dijkstra Algo
            </button>
            <div className='grid'>
                {grid.map((row, rowIndex) => {
                    return (
                        <div key={rowIndex}>
                            {row.map((node, nodeIndex) => {
                                const {row, column, isStart, isFinish, isWall} = node;
                                return (
                                    <Node 
                                        key={nodeIndex}
                                        column={column}
                                        isStart={isStart}
                                        isFinish={isFinish}
                                        isWall={isWall}
                                        mouseIsPressed={mouseIsPressed}
                                        onMouseDown={(row, column) => handleMouseDown(row, column)}
                                        onMouseEnter={(row, column) => handleMouseEnter(row, column)}
                                        onMouseUp={() => handleMouseUp()}
                                        row={row}
                                    />
                                );
                            }
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
        
    )

    
}

export default Dijkstra;